module.exports = __webpack_public_path__ + "static/img/flash-sale-banner.2bc682c9.png";